/** Restore once per story/source, or after an explicit failed-load recovery. */
export function shouldRestoreStoryAudio(
  restoredSlug: string | null,
  slug: string,
  pendingSeconds: number,
): boolean {
  return restoredSlug !== slug || pendingSeconds > 0;
}